import React from "react";
import "./Loader_holder.css"; // Add styles for the popup
import Loader from "./Animation/Loader";

const Loader_holder = ({ text, onClose }) => {
  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content">
        <Loader />
      </div>
    </div>
  );
};

export default Loader_holder;
